<template lang="pug">
  footer(:class="[$style.footer, $style.foreignFooter, isRebrand ? $style.rebrandPadding : '']")
    div(
      :class="isRebrand? $style.rebrandLayout : ''"
      class="container font-semibold"
    )
      div(class="flex flex-col md:flex-row md:justify-between")
        div(:class="$style.trustPilot")
          client-only
            Trustpilot(
              theme="light"
              :width="Breakpoints_matchMedia('md') ? null : 168")
        div(:class="$style.contact")
          div(class="mb-ds-xs hidden md:block")
            PhoneNumber(
              :font-size="25"
              show-text)
          i18n-t(
            keypath="footer.availability"
            tag="p"
            class="mb-ds-md text-xs hidden md:block"
            scope="global")
            template(#br)
              br
          p(class="mb-ds-ms text-2xl hidden md:block")
            a(:href="emailHref")
              | {{email}}

        nav(:class="$style.links")
          a(:href="`${getUrlByHostVersion('footer_about_us')}`") {{ $t('footer.about_us') }}
          a(:href="`${v4Host}/categories`") {{ $t('footer.get_quotes') }}
          a(v-if="user" :href="`${v4Host}/mon-compte`") {{ $t('footer.my_anyvan') }}
          a(:href="`${v4Host}/faqs/customer`") {{ $t('footer.faq') }}
          a(:href="`${getUrlByHostVersion('footer_contact_us')}`") {{ $t('footer.contact_us') }}
          a(:href="`${$config.public.v4Host}/fr/devenir-transporteur-anyvan`") {{ $t('footer.drive_with_anyvan') }}
        div(:class="$style.contact")
          img(
            class="inline-flex md:hidden fixed-size justify-center"
            src="~/assets/img/footer/PCI_DSS_Validated.webp"
            loading="lazy"
            width="82"
            height="45"
            alt="verify logo")
        client-only
          Trustpilot(
            class="hidden md:block w-[200px]"
            style="padding-left: 0;"
            theme="light"
            :width="Breakpoints_matchMedia('sm') ? null : 168")
      hr(:class="$style.hr")

      div(:class="$style.legal")
        div
        div(class="hidden text-right md:block lg:hidden")
          img(
            class="inline-block fixed-size"
            :class="$style.pciDssValidated"
            src="~/assets/img/footer/PCI_DSS_Validated.webp"
            loading="lazy"
            width="82"
            height="45"
            alt="verify logo")
        div(:class="$style.copy")
          nav
            a(:href="`/fr/politique-de-confidentialite`" target="_blank")
              | {{ $t('footer.privacy_policy') }}
            a(:href="`/fr/mentions-legales`" target="_blank")
              | {{ $t('footer.terms_and_conditions') }}
            a(:href="`${v4Host}/plan-du-site`")
              | {{ $t('footer.sitemap') }}
          div(:class="$style.copy")
            div(class="text-2xs text-center md:text-sm md:text-left")
              | {{ $t('footer.copyright', { currentYear }) }}
            div(class="hidden text-right md:block lg:hidden")
              img(
                class="inline-block fixed-size"
                :class="$style.pciDssValidated"
                src="~/assets/img/footer/PCI_DSS_Validated.webp"
                loading="lazy"
                width="82"
                height="45"
                alt="verify logo")

</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import FooterBase from "~/components/base/footerBase"
import { GET_USER } from "~/store/auth"
import { getV4Host } from "~/scripts/useful-functions"
import { frConfig } from "~/services/public/FrConfig"

export default defineComponent({
  name: "TheFooterFR",
  extends: FooterBase,
  data() {
    return {
      frConfigUrls: frConfig['v2']
    }
  },
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    }),
    v4Host(): string {
      return getV4Host(this.$config.public.v4Host, "fr")
    }
  },
  methods: {
    getUrlByHostVersion(urlName: keyof typeof frConfig.v2): string {
      const url = this.frConfigUrls[urlName]
      if (url.includes("/fr/")) {
        return this.$config.public.v4Host + url
      } else {
        return this.v4Host + url
      }
    }
  },
  mounted() {
    if (window?.av?.context?.featureFlags?.fr_prelisting_routing_destination === 'v4') {
      this.frConfigUrls = frConfig['v4']
    }
  }
})
</script>

<style lang="scss" module>
@import "~/assets/scss/footer.scss";
</style>
